import { Observable, catchError, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiReportResponse } from '@navstation-portal/reporting/data-model/offshore-report';
import { ReducedOffshoreReport } from '@navstation-portal/reporting/data-model/offshore-reports';
import { ApiErrorMapper, BASE_API_V2_URL } from '@navstation-portal/shared/util/api';

const REPORT_ROUTE = 'api/reports';

@Injectable({ providedIn: 'root' })
export class OffshoreReportsService {
  private http = inject(HttpClient);
  private readonly baseUrl = inject(BASE_API_V2_URL);
  private apiError = inject(ApiErrorMapper).forFeature('OffshoreReports');

  getOffshoreReports(vesselId?: string): Observable<ReducedOffshoreReport[]> {
    return this.http.get<ApiReportResponse[]>(`${this.baseUrl}/${REPORT_ROUTE}`).pipe(
      map((response): ReducedOffshoreReport[] => {
        const res = Object.entries(response).map(
          ([_, report]): ReducedOffshoreReport => ({
            id: report.report_id,
            reportNumber: report.fields.operational?.reportDetails?.reportNumber || -1,
            reportFrom: report.period_from ? new Date(report.period_from).toISOString() : '',
            reportTo: report.period_to ? new Date(report.period_to).toISOString() : '',
            reportPeriod: report.fields.operational?.reportDetails?.reportPeriod || -1,
            event: report.event || '',
            operation: report.operation || '',
            status: report.status,
          })
        );
        return res;
      }),
      catchError(this.apiError.toApiError('getting offshore reports'))
    );
  }
}
